export const LOADING = 'invoices/LOADING';
export const GET_ALL_INVOICES = 'invoices/GET_ALL_INVOICES';